module.exports = __webpack_public_path__ + "img/grid-endtoend.4d56bde4.png";